// extracted by mini-css-extract-plugin
export var aboveInput = "_i8-0";
export var actionButton = "_i8-5";
export var actionButtonContainer = "_i8-1";
export var actionIcon = "_i8-6";
export var aiInfoContainer = "_i8-2";
export var attachmentWrapper = "_i8-7";
export var bold = "_i8-3";
export var checkIcon = "_i8-8";
export var clickingRecipientBar = "_i8-11";
export var commentThreadSwitch = "_i8-a";
export var draftImage = "_i8-b";
export var draftImageContainer = "_i8-c";
export var draftImages = "_i8-e";
export var editButton = "_i8-g";
export var editor = "_i8-f";
export var editorContainer = "_i8-y";
export var editorErrorTooltipWrapper = "_i8-9";
export var headerDivider = "_i8-h";
export var icon = "_i8-i";
export var info = "_i8-j";
export var internal = "_i8-n";
export var internalDivider = "_i8-k";
export var internalMessage = "_i8-l";
export var messageInputCard = "_i8-m";
export var messageInputForm = "_i8-o";
export var messageInputFormInternal = "_i8-p";
export var options = "_i8-q";
export var publicMessageCustomer = "_i8-s";
export var publicMessageMerchant = "_i8-r";
export var removeImageButton = "_i8-d";
export var replyButtons = "_i8-t";
export var showSignatureButton = "_i8-u";
export var spinner = "_i8-v";
export var verticalButtonDivider = "_i8-4";
export var visibilitySelector = "_i8-w";
export var warning = "_i8-x";
export var wrappingText = "_i8-z";
export var writingInternalNoteTopBorder = "_i8-10";